import React, { createContext, useReducer } from 'react'

export const SET_INSPECTION_POINTS_DATA = 'SET_INSPECTION_POINTS_DATA'

export const SET_SHOW_HIDE_INSPECTION_POINTS_UPLOAD_POPUP =
  'SET_SHOW_HIDE_INSPECTION_POINTS_UPLOAD_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_INSPECTION_POINTS_DATA: {
      return { ...data, data: payload.data }
    }
    case SET_SHOW_HIDE_INSPECTION_POINTS_UPLOAD_POPUP: {
      if (payload.data) {
        return { ...data, showInspectionPointUploadForm: payload.data }
      } else {
        return {
          ...data,
          showInspectionPointUploadForm: payload.data,
          selectedObject: {},
        }
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: {},
  selectedObject: {},
  showInspectionPointUploadForm: false,
}

const InSpectionPointsStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <InSpectionPointsContext.Provider value={[state, dispatch]}>
      {children}
    </InSpectionPointsContext.Provider>
  )
}

export const InSpectionPointsContext = createContext(initialState)
export default InSpectionPointsStore
